"use strict";

exports.__esModule = true;
exports.fileDownloaded = exports.RCE_FILE_DOWNLOADED = exports.fileUploaded = exports.RCE_FILE_UPLOADED = exports.mediaStudioOpened = exports.MEDIA_STUDIO_OPENED = void 0;

var _createAction = _interopRequireDefault(require("../services/create-action"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MEDIA_STUDIO_OPENED = 'mediaStudio/OPENED';
exports.MEDIA_STUDIO_OPENED = MEDIA_STUDIO_OPENED;
var mediaStudioOpened = (0, _createAction["default"])(MEDIA_STUDIO_OPENED);
exports.mediaStudioOpened = mediaStudioOpened;
var RCE_FILE_UPLOADED = 'rce/FILE_UPLOADED';
exports.RCE_FILE_UPLOADED = RCE_FILE_UPLOADED;
var fileUploaded = (0, _createAction["default"])(RCE_FILE_UPLOADED);
exports.fileUploaded = fileUploaded;
var RCE_FILE_DOWNLOADED = 'rce/FILE_DOWNLOADED';
exports.RCE_FILE_DOWNLOADED = RCE_FILE_DOWNLOADED;
var fileDownloaded = (0, _createAction["default"])(RCE_FILE_DOWNLOADED);
exports.fileDownloaded = fileDownloaded;